(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('theme-scrolling-list')) {
    customElements.define('theme-scrolling-list', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.theme-scrolling-list__viewport')
        this.track = this.querySelector('.theme-scrolling-list__track')
        this.source = this.querySelector('[data-scrolling-source]')
        if (!this.viewport || !this.track || !this.source) return
        this.fill = this.fill.bind(this)
        this.resize = new ResizeObserver(this.fill)
        this.resize.observe(this.viewport)
        this.resize.observe(this.source)
        if (document.fonts?.ready) document.fonts.ready.then(this.fill)
        this.fill()
      }

      disconnectedCallback() {
        this.resize?.disconnect()
      }

      fill() {
        if (this.filling) return
        this.filling = true
        this.resize.unobserve(this.viewport)
        this.resize.unobserve(this.source)
        this.querySelectorAll('[data-scrolling-clone]').forEach((node) => node.remove())
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        const sourceWidth = this.source.scrollWidth
        const viewportWidth = this.viewport.clientWidth
        if (reduced || sourceWidth === 0 || viewportWidth === 0) {
          this.toggleAttribute('data-static', true)
          this.filling = false
          this.resize.observe(this.viewport)
          this.resize.observe(this.source)
          return
        }
        this.toggleAttribute('data-static', false)
        const copies = Math.max(1, Math.ceil(viewportWidth / sourceWidth))
        for (let index = 1; index < copies; index++) this.track.appendChild(this.clone(this.source))
        for (const child of [...this.track.children]) this.track.appendChild(this.clone(child))
        const speed = { slow: 40, normal: 70, fast: 120 }[this.dataset.speed] || 70
        this.style.setProperty('--scrolling-list-duration', `${Math.max(8, this.track.scrollWidth / 2 / speed)}s`)
        this.filling = false
        this.resize.observe(this.viewport)
        this.resize.observe(this.source)
      }

      clone(node) {
        const copy = node.cloneNode(true)
        const suffix = `-${Math.random().toString(36).slice(2, 10)}`
        copy.removeAttribute('data-scrolling-source')
        copy.setAttribute('data-scrolling-clone', '')
        copy.setAttribute('aria-hidden', 'true')
        copy.setAttribute('inert', '')
        copy.querySelectorAll('[id]').forEach((element) => {
          const previous = element.id
          const next = `${previous}${suffix}`
          element.id = next
          copy.querySelectorAll('style').forEach((style) => {
            style.textContent = style.textContent.replaceAll(previous, next)
          })
        })
        return copy
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
